import { __assign, __read } from "tslib";
import React, { useEffect, useState } from 'react';
export var LoadingSpinner = function (props) {
    var _a;
    var _b = __read(useState(Date.now()), 2), time = _b[0], setTime = _b[1];
    var isFirefox = ((_a = navigator === null || navigator === void 0 ? void 0 : navigator.userAgent) === null || _a === void 0 ? void 0 : _a.indexOf('Firefox')) !== -1;
    useEffect(function () {
        var interval = setInterval(function () {
            setTime(Date.now());
        }, 5000);
        return function () { return clearInterval(interval); };
    }, []);
    return (React.createElement("span", __assign({}, props),
        React.createElement("svg", { style: {
                filter: 'drop-shadow(0 0 0.5px #ccc)',
                position: 'absolute',
            }, width: "144", height: "63", viewBox: "0 0 144 63", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React.createElement("path", { d: "M72 21L108 42L72 62.5V21Z", fill: "#eee" }),
            React.createElement("path", { d: "M108 42L72 21L108 0V42Z", fill: "#eee" }),
            React.createElement("path", { d: "M108 42L144 21L108 0V42Z", fill: "#eee" }),
            React.createElement("path", { d: "M144 21L108 42L144 62.5V21Z", fill: "#eee" }),
            React.createElement("path", { d: "M72 21L36 42L72 62.5V21Z", fill: "#eee" }),
            React.createElement("path", { d: "M36 42L72 21L36 0V42Z", fill: "#eee" }),
            React.createElement("path", { d: "M0 21L36 42L0 62.5V21Z", fill: "#eee" }),
            React.createElement("path", { d: "M36 42L0 21L36 0V42Z", fill: "#eee" })),
        React.createElement("svg", { style: {
                filter: 'drop-shadow(0 1px 1px #ccc)',
                position: 'relative',
            }, width: "144", height: "63", viewBox: "0 0 144 63", fill: "none", xmlns: "http://www.w3.org/2000/svg", key: time },
            React.createElement("g", { id: "spinner-slice5", className: "origin-[25%_0%] animate-slice5", style: {
                    transformBox: 'fill-box',
                    transformOrigin: isFirefox ? '86% 0%' : '',
                } },
                React.createElement("path", { d: "M72 21L108 42L72 62.5V21Z", fill: "#6E63AC" }),
                React.createElement("g", { style: {
                        transformBox: 'fill-box',
                        transformOrigin: isFirefox ? '98% 100%' : '',
                    }, className: "origin-[100%_100%] animate-slice6 ", id: "spinner-slice6" },
                    React.createElement("path", { d: "M108 42L72 21L108 0V42Z", fill: "#6E63AC" }),
                    React.createElement("g", { style: {
                            transformBox: 'fill-box',
                            transformOrigin: isFirefox ? '67% 0%' : '',
                        }, className: "origin-[33%_0%] animate-slice7", id: "spinner-slice7" },
                        React.createElement("path", { d: "M108 42L144 21L108 0V42Z", fill: "#323189" }),
                        React.createElement("g", { className: "origin-[100%_0%] animate-slice8", style: { transformBox: 'fill-box' }, id: "spinner-slice8" },
                            React.createElement("path", { id: "spinner-slice8-path", d: "M144 21L108 42L144 62.5V21Z", className: "fill-inherit" }))))),
            React.createElement("g", { style: {
                    transformBox: 'fill-box',
                    transformOrigin: isFirefox ? '50% 0%' : '',
                }, className: "origin-[74%_0%] animate-slice4", id: "spinner-slice4" },
                React.createElement("path", { d: "M72 21L36 42L72 62.5V21Z", fill: "#6E63AC" }),
                React.createElement("g", { style: {
                        transformBox: 'fill-box',
                        transformOrigin: isFirefox ? '33% 100%' : '',
                    }, className: "origin-[0%_100%] animate-slice3", id: "spinner-slice3" },
                    React.createElement("path", { d: "M36 42L72 21L36 0V42Z", fill: "#6E63AC" }),
                    React.createElement("g", { style: { transformBox: 'fill-box' }, id: "spinner-slice2", className: "origin-[67%_0%] animate-slice2" },
                        React.createElement("path", { d: "M36 42L0 21L36 0V42Z", fill: "#323189" }),
                        React.createElement("g", { style: { transformBox: 'fill-box' }, id: "spinner-slice1", className: "origin-[0%_0%] animate-slice1" },
                            React.createElement("path", { id: "spinner-slice1-path", d: "M0 21L36 42L0 62.5V21Z", className: "fill-inherit" }))))))));
};
export default LoadingSpinner;
